import portalCommunication from '@3plearning/mathletics-portal-communication-service';

export default class PortalCommunication {
  static loadingSpinnerOff() {
    portalCommunication.requestLoadingSpinner(false);
  }

  // invoke this method to let the 3p-portal know
  // that we want to navigate to current module landing screen
  static navigateToLandingScreen(moduleName = '') {
    portalCommunication.requestNavigateToLanding(moduleName);
  }

  static serverError(error) {
    portalCommunication.requestServerError(error);
  }

  static informModuleChange(moduleId) {
    portalCommunication.informModuleChange(moduleId);
  }

  static requestLoadingSpinner(bool) {
    portalCommunication.requestLoadingSpinner(bool);
  }

  static requestInfoModal(girlIds) {
    portalCommunication.requestDucsModal(girlIds);
  }
}
